import * as ko from "knockout";
import * as $ from "jquery";
export interface BaoPagerParams {
    pageSize: KnockoutObservable<number>;
    pageIndex: KnockoutObservable<number>;
    totalRows: KnockoutObservable<number>;
    urlFn?: (pageNumber: number) => string;
    pageSizeVisible?: KnockoutObservable<boolean> | boolean;
    pageSizeOptions?: KnockoutObservableArray<number> | number[];
    loaded?: (pager: BaoPager) => void;
}

export class Page {
    constructor(public PageNumber: number, public IsActive: boolean) {
        this.Caption = this.PageNumber + "";
    }
    public Url = "";
    public Caption: string = "";
    public Click = (event) => {
    };
}
export class BaoPager {
    constructor(params: BaoPagerParams) {
        if (params != null) {
            this.PageSizeViewModel = params.pageSize;
            this.PageSize(ko.unwrap(this.PageSizeViewModel));
            this._pageIndex = params.pageIndex;
            this.TotalRows = params.totalRows;
            this._subs.push(this.PageSize.subscribe(() => {
                this.initPages();
                this.syncPageSizes();
            }));
            this._subs.push(this.PageSizeViewModel.subscribe((newValue) => {
                this.PageSize(newValue);
            }));
            this._subs.push(this._pageIndex.subscribe(() => { this.initPages(); }));
            this._subs.push(this.TotalRows.subscribe(() => { this.initPages(); }));
            if (params.pageSizeVisible == null) {
                this.PageSizeVisible = ko.observable(true);
            }
            else if (ko.isObservable(params.pageSizeVisible)) {
                this.PageSizeVisible = params.pageSizeVisible;
            }
            else {
                this.PageSizeVisible = ko.observable(params.pageSizeVisible);
            }
            if (params.pageSizeOptions == null) {
                this.PageSizeOptions = ko.observableArray([20, 50, 100, 200]);
            }
            else if (ko.isObservable(params.pageSizeOptions)) {
                this.PageSizeOptions = params.pageSizeOptions;
            }
            else {
                this.PageSizeOptions = ko.observableArray(params.pageSizeOptions);
            }
            this._urlFn = params.urlFn;
            this.initPages();
            if (params.loaded != null) {
                setTimeout(() => {
                    params.loaded(this);
                }, 1);
            }
        }
    }
    private _subs: KnockoutSubscription[] = [];
    private _pageIndex: KnockoutObservable<number>;
    private _urlFn: (pageNumber: number) => string;
    private _maxVisiblePages = 7;
    public TotalRows: KnockoutObservable<number>;
    public PageSize: KnockoutObservable<number> = ko.observable<number>();
    public PageSizeViewModel: KnockoutObservable<number>;
    public PageSizeVisible: KnockoutObservable<boolean>;
    public PageSizeOptions: KnockoutObservableArray<number>;
    public Pages: KnockoutObservableArray<Page> = ko.observableArray<Page>();
    private _gapDelta: number = 0;
    private initPages(gap?: number) {
        if (gap == null) {
            this._gapDelta = 0;
        }
        else {
            this._gapDelta = this._gapDelta + gap;
        }
        let createdPages: Page[] = [];
        let totalRows = this.TotalRows();
        let pageSize = this.PageSize();
        let pageIndex = this._pageIndex();
        if (totalRows > 0) {
            let modTotal = totalRows % pageSize;
            let pageCount = (totalRows - modTotal) / pageSize;
            if (modTotal > 0) {
                pageCount = pageCount + 1;
            }
            let selectedPage = pageIndex + 1;
            let selectedPageGap = selectedPage + this._gapDelta;
            let gapStartVisible = false;
            let gapEndVisible = false;
            let pageStart = 1;
            let pageEnd = pageCount;
            let gapModifikator = (this._maxVisiblePages - (this._maxVisiblePages % 2)) / 2;
            let startDelta = 0;
            if (pageCount <= this._maxVisiblePages) {
            }
            else {
                if (selectedPageGap - gapModifikator > 1) {
                    gapStartVisible = true;
                    pageStart = selectedPageGap - gapModifikator + 1;
                }
                else {
                    startDelta = (selectedPageGap - gapModifikator) * -1 + 1;
                }
                if (selectedPageGap + gapModifikator < pageCount) {
                    gapEndVisible = true;
                    pageEnd = selectedPageGap + gapModifikator - 1 + startDelta;
                }
                else {
                    pageStart = pageStart - (selectedPageGap + gapModifikator - pageCount);
                }
            }
            if (gapStartVisible) {
                createdPages.push(this.createPage(1, selectedPage == 1));
                let gapPageDown = this.createPage(-1, false, "...");
                gapPageDown.Click = this.clickGapDown;
                createdPages.push(gapPageDown);
            }
            for (let i = pageStart; i <= pageEnd; i++) {
                createdPages.push(this.createPage(i, i == selectedPage));
            }
            if (gapEndVisible) {
                let gapPageUp = this.createPage(-1, false, "...");
                gapPageUp.Click = this.clickGapUp;
                createdPages.push(gapPageUp);
                createdPages.push(this.createPage(pageCount, selectedPage == pageCount));
            }
        }
        this.Pages(createdPages);
    }
    private syncPageSizes() {
        let pageSizeNumber = parseInt(this.PageSize() + ""); //PageSize could be a string, because of html select
        if (isNaN(pageSizeNumber) == false) {
            this.PageSizeViewModel(pageSizeNumber);
        }
    }
    private createPage = (pageNumber: number, isActive: boolean, caption?: string): Page => {
        let p = new Page(pageNumber, isActive);
        if (caption != null) {
            p.Caption = caption;
        }
        if (isActive == false) {
            p.Click = this.clickFn;
        }
        if (this._urlFn != undefined && $.isFunction(this._urlFn)) {
            let url = this._urlFn(pageNumber);
            p.Url = url;
        }
        return p;
    };
    private clickFn = (page: Page) => {
        if (page != null && page.PageNumber != null && page.PageNumber > -1) {
            this._pageIndex(page.PageNumber - 1);
        }
    };
    public clickGapDown = (page: Page) => {
        this.initPages(-1 * (this._maxVisiblePages - 2));
    };
    public clickGapUp = (page: Page) => {
        this.initPages(this._maxVisiblePages - 2);
    };
    public dispose() {
        if (this._subs != null && this._subs.length > 0) {
            ko.utils.arrayForEach(this._subs, (s) => {
                s.dispose();
            });
        }
    }
}